import axios from 'axios';
import store from '../store/main';
import {formatTime} from '../utils/formatTime';
import _ from 'lodash';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  responseType: 'json',
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  }
});

export function postData(data) {

  console.log('******************* DATA *******************', data );
  let time = formatTime();
  // Performing a POST request

  let params =  window.location.search.split('&');
  const path = params[0].replace('?','');
  return api.post(`/callDialog/${path.toUpperCase()}`, data )
    .then((result) => {
      console.log(result);
      document.getElementById("bar").disabled=false;
      document.getElementById("bar").focus();

      let botResponse = null;
      let parameters = null;
      let options = null;
      let buttons = null;
      
      if (result.data) {
        botResponse = result.data.messages;
        parameters = result.data.parameters;
      }

      if (parameters)
      if(parameters.options){ 
        if(parameters.options.split(',').length === 2){
          buttons = parameters.options.split(',');
        }else{
          options = parameters.options.split(',');
        }
      }

      //redirect jivo chat
      if(parameters.link){
        _.delay(() => {
          window.open(parameters.link, '_self');
        }, 5000);
      }

      let i = 0;
      
      botResponse.map((message)=>{
        i++; 
        return _.delay(()=>{
          console.log('loading - ', store.messages.loading);
          store.currentBotMessage = message;
          store.parameters = parameters;
          store.messages.push({
            owner: 'bot',
            text: message,
            buttons,
            options,
            time,
            loading: true
          });
        },600*i)
      })
    });
}

